// Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Col, Container, Row } from 'reactstrap';
import CGIAR_NEW from '../../assets/Images/cgiar_neww.svg';
import Twitter from '../../assets/Images/icons/akar-icons_twitter-fill.svg';
import Facebook from '../../assets/Images/icons/bx_bxl-facebook-circle.svg';
import Flickr from '../../assets/Images/icons/bx_bxl-flickr.svg';
import LinkedIn from '../../assets/Images/icons/bx_bxl-linkedin.svg';
import Youtube from '../../assets/Images/icons/bx_bxl-youtube.svg';
import Mail from '../../assets/Images/icons/fluent_mail-16-filled.svg';
import RSSFeed from '../../assets/Images/icons/ic_twotone-rss-feed.svg';
import IWMI_NEW from '../../assets/Images/iwmi_neww.svg';
import DNA_LOGO from '../../assets/Images/logo_DNA_Mali-removebg-preview.png';
import AGRI_MINI_LOGO from '../../assets/Images/logo_Agric_Ministry_Mali-removebg-preview.png';
import WAPOR_LOGO from '../../assets/Images/WaPOR_wordmark-removebg.png';
import PUBLIC_ICAR_NEW_LOGO from '../../assets/Images/publicICARLogo.svg';
import { getToken, isLogedIn } from '../../Components/common/utils';
import myConstClass from '../../Constants';

const Footer = ({ backgroundColor }) => {
  const { t } = useTranslation();

  let history = useHistory();
  const URLParams = new URLSearchParams(window.location.search);
  const queryCountry = URLParams.get('Country');

  return (
    <>
      {!isLogedIn() ? (
        <div className={`pre-footer ${backgroundColor}`}>
          <div className="pre-footer-content">
            <p className="contact-text">{t('HOME_PAGE.KEEP_IN_TOUCH')}</p>
            <span>
              {t('HOME_PAGE.REGISTER')}
              {!getToken() ? (
                <button
                  className="pre-footer-register-btn"
                  onClick={() => history.push('/register')}
                >
                  {t('HOME_PAGE.REGISTER_NOW')}
                </button>
              ) : null}
            </span>
          </div>
        </div>
      ) : null}
      <div className="footer-section" id="footer">
        <Container fluid className="footer-container">
          {/* TOP SECTION */}
          <Row className="py-4">
            {/* COLUMN 1 — Logos */}
            <Col md="4" className="px-0 d-flex flex-column align-items-start">
              <div className="logo-grid">
                <div className="d-flex align-items-center mb-3 flex-wrap">
                  <img src={IWMI_NEW} className="logos me-3" />
                  <img src={CGIAR_NEW} className="logos me-3" />
                  <img src={DNA_LOGO} className="logos me-3" />
                </div>

                <div className="d-flex align-items-center flex-wrap">
                  <img src={AGRI_MINI_LOGO} className="logos me-3" />
                  <img src={WAPOR_LOGO} className="logos logos-wapor me-3" />

                  {queryCountry === 'india' && (
                    <img src={PUBLIC_ICAR_NEW_LOGO} className="logos me-3" />
                  )}
                </div>
              </div>
            </Col>

            {/* COLUMN 2 — Contact */}
            <Col md="4" className="px-4 text-center text-white">
              <h5 className="mb-3">Contact Us</h5>
              <p className="mb-0">
                Direction Nationale de l’Agriculture
                <br />
                Rue Mohamed V, Porte 74, BP: 1098,
                <br />
                Bamako, Mali
                <br />
                +223 20 22 28 77
              </p>
            </Col>

            {/* COLUMN 3 — Social */}
            <Col md="4" className="px-0 text-center">
              <h5 className="follow-us text-center mb-3">Follow Us</h5>

              <div className="social-icons d-flex justify-content-center gap-3">
                <a href={myConstClass.IWMI_FB_URL} target="_blank">
                  <img src={Facebook} alt="Facebook" />
                </a>

                <a href="#">
                  <img src={Flickr} alt="Flickr" />
                </a>

                <a href="#">
                  <img src={LinkedIn} alt="LinkedIn" />
                </a>

                <a href="#">
                  <img src={Mail} alt="Email" />
                </a>

                <a href={myConstClass.IWMI_TWITTER_LINK} target="_blank">
                  <img src={Twitter} alt="Twitter" />
                </a>

                <a href="#">
                  <img src={RSSFeed} alt="RSS" />
                </a>

                <a href={myConstClass.IWMI_YOUTUBE_LINK} target="_blank">
                  <img src={Youtube} alt="YouTube" />
                </a>
              </div>
            </Col>
          </Row>

          {/* BOTTOM SECTION */}
          <Row className="mt-4">
            <Col md="6" className="text-md-left">
              <div className="copyright">
                <a
                  href="https://www.iwmi.org/copyright/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none', color: 'white' }}
                >
                  <span className="copy-icon">&copy;</span>
                  {new Date().getFullYear()} {t('FOOTER.IWMI_TEXT')}
                </a>
              </div>
            </Col>

            <Col md="6" className="text-end">
              <a href="/terms-conditions" style={{ textDecoration: 'none', color: 'white' }}>
                <span className="terms">Terms & Conditions</span>
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;
